import { configureStore } from '@reduxjs/toolkit'
import userReducer from './userReducer'
import portfolioReducer from './portfolioReducer'
import miscReducer from './miscReducer'
import assetsLogReducer from './assetsLogReducer'

export const store = configureStore({
  reducer: {
    user: userReducer,
    portfolio: portfolioReducer,
    misc: miscReducer,
    assetLogs: assetsLogReducer,
  },
})

export type RootState = ReturnType<typeof store.getState>

export type AppDispatch = typeof store.dispatch







